function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computePercentageProgress = exports.CampaignTargetType = exports.CampaignTargetTextPositionType = exports.CampaignTarget = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _SvgImage = require("../SvgImage");
var _SVG = require("../SVG");
var _useStyles2 = require("../../styles/STYLES/useStyles");
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var CampaignTargetType = exports.CampaignTargetType = function (CampaignTargetType) {
  CampaignTargetType["ParticipantsCount"] = "participants_count";
  CampaignTargetType["PendingCommitmentsCount"] = "pending_commitments_count";
  CampaignTargetType["SuccessfulCommitmentsCount"] = "successful_commitments_count";
  return CampaignTargetType;
}({});
var CampaignTargetTextPositionType = exports.CampaignTargetTextPositionType = function (CampaignTargetTextPositionType) {
  CampaignTargetTextPositionType["inside"] = "inside";
  CampaignTargetTextPositionType["bottom"] = "bottom";
  return CampaignTargetTextPositionType;
}({});
var IMAGES = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, CampaignTargetType.ParticipantsCount, require("./Images/ParticipantsCount.svg")), CampaignTargetType.PendingCommitmentsCount, require("./Images/PendingCommitmentsCount.svg")), CampaignTargetType.SuccessfulCommitmentsCount, require("./Images/SuccessfulCommitmentsCount.svg"));
var computePercentageProgress = exports.computePercentageProgress = function computePercentageProgress(currentValue, targetValue) {
  if (!currentValue || !targetValue) return 0;
  if (currentValue >= targetValue) return 1;
  return currentValue / targetValue;
};
var CampaignTarget = exports.CampaignTarget = (0, _react.memo)(function (_ref) {
  var attribute = _ref.attribute,
    current = _ref.current,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? true : _ref$selected,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 300 : _ref$size,
    _ref$strokeWidthPerce = _ref.strokeWidthPercentage,
    strokeWidthPercentage = _ref$strokeWidthPerce === void 0 ? 0.14 : _ref$strokeWidthPerce,
    target = _ref.target,
    _ref$textPosition = _ref.textPosition,
    textPosition = _ref$textPosition === void 0 ? CampaignTargetTextPositionType.inside : _ref$textPosition,
    svgProps = _ref.svgProps,
    _ref$showBackgroundCo = _ref.showBackgroundColour,
    showBackgroundColour = _ref$showBackgroundCo === void 0 ? false : _ref$showBackgroundCo;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useGlobalStyles = (0, _useStyles2.useStyles)(),
    COLORS = _useGlobalStyles.COLORS;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _viewBox = "0 0 ".concat(size, " ").concat(size);
  var _squareCenter = size / 2;
  var _strokeWidth = size * strokeWidthPercentage;
  var _defaultImageOffset = size * 0.1;
  var _defaultImageSize = size - _strokeWidth * 2;
  var _imageShouldOffset = textPosition === 'inside';
  var _imageOffset = _imageShouldOffset ? _defaultImageOffset : 0;
  var _imageSize = _defaultImageSize - _imageOffset;
  var _defaultImagePosition = (size - _imageSize) / 2;
  var _imagePositionX = _defaultImagePosition;
  var _imagePositionY = _defaultImagePosition + _imageOffset / 2;
  var _progressCircleRadius = (size - _strokeWidth) / 2;
  var _innerCircleRadius = _progressCircleRadius - _strokeWidth / 2;
  var _clipPathRadius = _progressCircleRadius - _strokeWidth / 2;
  var _progressStrokeDashArray = _progressCircleRadius * Math.PI * 2;
  var _progressStrokeDashOffsetInitial = _progressStrokeDashArray;
  var _strokeDashOffsetEnd = _progressStrokeDashOffsetInitial - _progressStrokeDashArray * computePercentageProgress(current, target);
  var _useState = (0, _react.useState)((0, _utils.GenerateId)()),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    id = _useState2[0];
  var _clipPathName = "Target__clipPath---".concat(id);
  var _currentString = Math.round(current);
  var _displayBottomText = textPosition === 'bottom';
  var _displayInnerText = textPosition === 'inside';
  var _innerTextPositionY = (strokeWidthPercentage + 0.1) * size - 16;
  return (0, _jsxRuntime.jsxs)(_reactNative.View, {
    style: styles.container,
    testID: "CampaignTarget",
    children: [(0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: {
        width: size,
        height: size
      },
      children: [(0, _jsxRuntime.jsxs)(_SVG.SVG.Svg, Object.assign({
        width: size,
        height: size,
        viewBox: _viewBox,
        fontSize: 0
      }, svgProps, {
        children: [(0, _jsxRuntime.jsx)(_SVG.SVG.Defs, {
          children: (0, _jsxRuntime.jsx)(_SVG.SVG.ClipPath, {
            id: _clipPathName,
            children: (0, _jsxRuntime.jsx)(_SVG.SVG.Circle, {
              cx: _squareCenter,
              cy: _squareCenter,
              r: _clipPathRadius
            })
          })
        }), selected && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsx)(_SVG.SVG.Circle, {
            cx: _squareCenter,
            cy: _squareCenter,
            r: _progressCircleRadius,
            strokeWidth: "".concat(_strokeWidth, "px"),
            fill: showBackgroundColour ? COLORS.snuff : COLORS.transparent,
            stroke: COLORS.mushroom
          }), (0, _jsxRuntime.jsx)(_SVG.SVG.Circle, {
            cx: _squareCenter,
            cy: _squareCenter,
            r: _progressCircleRadius,
            strokeWidth: "".concat(_strokeWidth, "px"),
            transform: "rotate(-90 ".concat(_squareCenter, " ").concat(_squareCenter, ")"),
            fill: 'none',
            stroke: COLORS.aubergine,
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeDasharray: _progressStrokeDashArray,
            strokeDashoffset: _strokeDashOffsetEnd
          })]
        }), !selected && showBackgroundColour && (0, _jsxRuntime.jsx)(_SVG.SVG.Circle, {
          cx: _squareCenter,
          cy: _squareCenter,
          r: _innerCircleRadius,
          fill: COLORS.snuff,
          strokeWidth: "".concat(_strokeWidth, "px"),
          stroke: COLORS.transparent
        }), (0, _jsxRuntime.jsx)(_SVG.SVG.Circle, {
          clipPath: "url(#".concat(_clipPathName, ")"),
          cx: _squareCenter,
          cy: _squareCenter,
          r: _innerCircleRadius,
          fill: COLORS.transparent
        }), (0, _jsxRuntime.jsx)(_SVG.SVG.G, {
          clipPath: "url(#".concat(_clipPathName, ")"),
          children: (0, _jsxRuntime.jsx)(_SVG.SVG.G, {
            transform: "translate(".concat(_imagePositionX, ",").concat(_imagePositionY, ")"),
            children: (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
              image: IMAGES[attribute],
              width: _imageSize,
              height: _imageSize,
              isNested: true
            })
          })
        })]
      })), _displayInnerText && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
          style: [styles.textInnerValue, {
            top: _innerTextPositionY
          }],
          children: _currentString
        }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
          style: [styles.textInnerType, {
            top: _innerTextPositionY + 24
          }],
          children: t("campaignTarget:".concat(attribute, ".type"))
        })]
      })]
    }), _displayBottomText && (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: styles.textContainer,
      testID: "CampaignTargetBottomText",
      children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: [styles.textValue],
        children: _currentString
      }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: [styles.textType],
        children: t("campaignTarget:".concat(attribute, ".type"))
      }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: [styles.description],
        children: t("campaignTarget:".concat(attribute, ".description"))
      })]
    })]
  });
});